import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { NgSelectModule } from '@ng-select/ng-select';
import { FormsModule } from '@angular/forms';
import { SelectPeriodComponent } from './select-period.component';


@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    NgSelectModule,
    FormsModule
  ],
  declarations: [SelectPeriodComponent],
  exports: [SelectPeriodComponent]
})
export class SelectPeriodModule {
}
